const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const RefreshIcon = require('@material-ui/icons/Refresh').default;
const withState = require('../../../../../utils/withState');
const {
  apiAdminMailSystemStates,
} = require('../../../../../api/admin/mailSystem');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading');
const ButtonD = require('../../../../dumb/Button/D');
const Item = require('./Item');

const REFRESH_TIMEOUT = 10000;


module.exports = withState((setState, self, onMount) => {
  let _cancel = noop;
  function updateBase() {
    _cancel();
    _cancel = apiAdminMailSystemStates({
      skipError: 1,
    }).finally((error, response) => {
      error || (_cancel = delay(update, REFRESH_TIMEOUT));
      setState({
        loading: false,
        loadingAuto: 0,
        error,
        states: response && response.states,
      });
    }).cancel;
  }
  function update(loading) {
    setState({
      loading: loading || 0,
      loadingAuto: 1,
    });
    updateBase();
  }
  function updateForce() {
    update(1);
  }

  onMount(() => {
    updateForce();
    return () => {
      _cancel();
    };
  });


  return (state) => {
    const {
      error,
      loading,
    } = state;

    return (
      <div>
        <div className="rlv">
          <WrapperWithLoading
            className="abs sb sr"
            loading={loading}
          >
            <ButtonD
              className="wmin100"
              onClick={updateForce}
            >
              <RefreshIcon/>
              <div className="pl15">Refresh</div>
            </ButtonD>
          </WrapperWithLoading>
        </div>
        <WrapperWithLoading
          className="pt10 bs b bv1 bcF1"
          loading={loading}
        >
          {
            error ? (
              <div
                className="hmin40 layoutRow fhaS fvaC ph15 pv5 cF00 bg0 r5"
              >
                <div>
                  <div className="f10">Error</div>
                  <div>{error.message}</div>
                </div>
              </div>
            ) : map(state.states, (v) => {
              return (
                <div
                  key={v.sender}
                  className="mb10"
                >
                  <Item
                    onChange={updateForce}
                    data={v}
                  />
                </div>
              );
            }, [])
          }
        </WrapperWithLoading>
      </div>
    );
  };
}, {});
